<script setup lang="ts">
import { UiText } from "@shopexperts/shared";
</script>

<template>
  <div class="flex flex-col items-center justify-center py-20 gap-3">
    <div class="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
      <svg class="w-5 h-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
      </svg>
    </div>
    <UiText as="p" variant="p" class="text-gray-500">
      Status history coming soon
    </UiText>
    <UiText as="p" variant="p-small" class="text-gray-400">
      Track project status changes and timeline
    </UiText>
  </div>
</template>
